module.exports = __webpack_public_path__ + "images/tour/cardback.3de48f0228a7b17e0e1b.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tour/cardback.svg
// module id = L+Pm
// module chunks = 1